export default {"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20};